import VenueStats from './VenueStats';

export default VenueStats;
